export function computeTotals(items = [], payments = []) {
  const subtotal = items.reduce((s, i) => s + (Number(i.amount) || 0), 0);
  const taxTotal = items.reduce((s, i) => s + (Number(i.tax) || 0), 0);
  const total = subtotal + taxTotal;
  const paid = payments.reduce((s, p) => s + (Number(p.amount) || 0), 0);
  const balance = total - paid;
  return {
    subtotal: Math.round(subtotal * 100) / 100,
    taxTotal: Math.round(taxTotal * 100) / 100,
    total: Math.round(total * 100) / 100,
    paid: Math.round(paid * 100) / 100,
    balance: Math.round(balance * 100) / 100,
  };
}

export const money = (n) => `$${(Number(n) || 0).toFixed(2)}`;
